import app from '../../app';
import { Config } from '@cian/config';
import { Store } from 'redux';
import { IAppState } from '../../../../../shared/redux';
import { getIsNewPublishTermsEnabled } from '../../../../../shared/utils/publishTerms';
import { selectIsAddJKState } from '../../../../../shared/selectors/jk';

export function publishTermsService(store: Store<IAppState>, config: Config) {
  const isNewPublishTermsEnabled = () => {
    const state = store.getState();
    const { abExperiments } = state;
    const { search } = window.location;

    const isAddJKState = selectIsAddJKState(state);

    return getIsNewPublishTermsEnabled({ config, abExperiments, search, isAddJKState });
  };

  return {
    isNewPublishTermsEnabled,
  };
}

app.service('publishTermsService', ['store', 'config', publishTermsService]);
